export default __webpack_public_path__ + "static/media/qr_phone.d7377b15.svg";